import { Layout, Button, Space, notification } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useMobileStore, useThemeStore } from '../../store';
import { setNavigator } from "../../utils/navigation";
import { useLogout } from '../../utils';
import { setLogout } from "../../utils/authService";
import ThemeButton from '../../components/ThemeButton/ThemeButton';
import Sidebar from './Sidebar';

import './Styles.scss';
import { apiClient } from '../../api_actions';
import { authClient } from '../../api_actions/auth_index';

const { Header, Content, Footer } = Layout;

export default function DummyLayout() {
  const [api, contextHolder] = notification.useNotification();
  const logout = useLogout();

   const openNotification = (placement, message) => {
    const btn = (
      <Space>
        <Button type="primary" size="small" onClick={
          async () => {
            await apiClient.post("read/foo")
            api.destroy()}
          }>
          Extend Session
        </Button>
      </Space>
    );
    api.open({
      title: 'Session Warning',
      description:
        `Your session will time out in ${message} minutes, and you will be logged out. Press 'extend session' to stay longer.`,
      btn,
      duration: 0,
      closeIcon: false,
      onClose: close,
    });
  }

  const countRef = useRef(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const timeout = Number(localStorage.getItem('timeout'));
      const current_time = Date.now()
      let difference = current_time - timeout
      const max_minutes =  60_000 * 15
      const ten_minutes =  60_000 * 10
      countRef.current += 1; // Always current, no stale closure
      if (difference > ten_minutes) {
        openNotification('top', Math.floor((max_minutes - difference)/60_000));
      }

      if (difference >= max_minutes) {
        logout()
      }

    }, 60_000);

    return () => clearInterval(intervalId);
  }, []);

  function InitNavigation() {
    const navigate = useNavigate();
    setNavigator(navigate);
    return null; // no UI
  }

  function InitAuth() {
    const logout = useLogout();

    useEffect(() => {
      setLogout(logout);
    }, [logout]);

    return null; // nothing rendered
  }

  const [collapsed, setCollapsed] = useState(false);
  const theme = useThemeStore((state) => state.theme);
  const updateTheme = useThemeStore((state) => state.updateTheme);
  const isMobile = useMobileStore((state) => state.isMobile);
  
return (
  <>
  {contextHolder}
  <Layout className='layout-container' style={{ height: '100vh' }}>
    <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />

    <Layout style={{ display: 'flex', flexDirection: 'column' }}>

      <Header className={`layout-header dark-theme`}>
        <h1 className='nav-title desktop' style={{ margin: 0 }}>
          Orbital Site Monitoring
        </h1>
      </Header>

      <Content className='content-wrapper'>
        <InitNavigation />
        <InitAuth />
        <Outlet />
      </Content>

      <Footer className={`layout-footer dark-theme`}>
        © {new Date().getFullYear()} Orbital Engineering. All Rights Reserved.
      </Footer>
    </Layout>
  </Layout>
  </>
);
}
